import React, { useState, useEffect } from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import callApi from '../../helpers/callapi'
import CONSTANTS from '../../constants/constants'
import Swal from 'sweetalert2'
import Colors from '../../constants/Colors'
import Cookies from 'js-cookie'

export default function AdminModal({ setIsVisible, onClose, isVisible, admin, onSuccess }) {
  const { username: userName, user_Id: id } = admin

  const [changePassword, setChangePassword] = useState(false)
  const [username, setUsername] = useState(userName)
  const [password, setPassword] = useState('')
  //const [openPassword, setOpenPassword] = useState(false)
  const [labelChecked, setLabelChecked] = useState('')
  //const [checkAdmin, setcheckAdmin] = useState("")

  const constantPermissionsAdmin = CONSTANTS.permissionsAdmin

  //const [checkedItems, setCheckedItems] = useState({...getPermistions}); //plain object as state

  // const handleChange = (event) => {
  //   setCheckedItems({[event.target.value]: event.target.checked });
  // }
  // let bbb = (Object.keys(checkedItems))
  // const per = CONSTANTS.permissionsAdmin[bbb] ? CONSTANTS.permissionsAdmin[bbb].permission : []

  const createAdmin = async () => {
    try {
      // const elCheckbox = document.querySelectorAll("input[type='checkbox']")
      // let pers = []
      // elCheckbox.forEach(el => {
      //   if(el.checked) {
      //     const per = CONSTANTS.permissionsAdmin[el.name] ? CONSTANTS.permissionsAdmin[el.name].permission : []
      //     pers = [...new Set([...pers, ...per])]
      //   }
      // })
      const body = {
        username: username,
        permissions: constantPermissionsAdmin[labelChecked].permission,
      }
      if (changePassword) {
        body.password = password
      }
      // console.log(body)
      // setLoading(true);
      await callApi({
        url: `/admins/${id}`,
        method: 'put',
        body,
      })
      // onSuccess(id)
      // setLoading(false);
      // setIsVisible(false);
      // onClose();
      // fetchOrders(currentPage);
    } catch (error) {
      console.error('Error while trying to fetch orders.', error)
      // setLoading(false);
    } finally {
      Swal.fire({
        title: `เพิ่มสิทธิ์แล้ว กรุณาออกจากระบบ และเข้าสู่ระบบอีกครั้ง`,
        icon: 'info',
        confirmButtonColor: `${Colors.SOFT_BLUE}`,
        confirmButtonText: 'ออกจากระบบ',
      }).then((result) => {
        Cookies.remove('accessToken')
        window.location.replace('/page-login')
      })
    }
  }
  useEffect(() => {
    callApi({ url: `/admins/${admin.user_Id}` })
      .then((res) => {
        const mePermissions = res.permissions.sort().join('')
        let permissions = ''
        Object.keys(constantPermissionsAdmin).forEach((key) => {
          permissions = constantPermissionsAdmin[key].permission.sort().join('')
          if (mePermissions === permissions) {
            setLabelChecked(key)
          }
        })
      })
      .catch((err) => console.log('err', err))
  }, [constantPermissionsAdmin, admin])

  return (
    <Modal className="fade bd-example-modal-lg" show={isVisible} size="lg">
      <Modal.Header>
        <Modal.Title>เพิ่มสิทธิ์การใช้งาน</Modal.Title>
        <Button variant="X" className="close" onClick={() => setIsVisible(false)}>
          <span>&times;</span>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col lg={12}>
            <Col xl={12}>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Username: </label>
                <div className="col-sm-9">
                  <input
                    type="username"
                    className="form-control"
                    placeholder="Username"
                    style={{ color: '#000000' }}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
              </div>
            </Col>
            {/* <Col xl={12}>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Password: </label>
                <div className="col-sm-9">
                  {changePassword ?
                    <div className="input-group mb-3 ">
                      <input type={openPassword ? "text" : "Password"} className="form-control" placeholder="Password" onChange={e => setPassword(e.target.value)} />
                      <div className="input-group-append">
                        <OpenPass className="input-group-text" onClick={() => setOpenPassword(!openPassword)}><Eye type={openPassword} /></OpenPass>
                      </div>
                    </div> :
                    <Button className='col-sm-12 col-form-label' variant='secondary light' onClick={() => setChangePassword(!changePassword)}>
                      <span>แก้ไขรหัสผ่าน</span>
                    </Button>
                  }
                </div>
              </div>
            </Col> */}

            <form onSubmit={(e) => e.preventDefault()} label="PermissionsAdmin" name="permissionsAdmin">
              <Row>
                {Object.values(constantPermissionsAdmin).map((value) => {
                  return (
                    <Col xl={4} key={value.permission}>
                      <input
                        type="radio"
                        name="label"
                        value={value.label}
                        checked={value.label === labelChecked ? true : false}
                        onChange={(e) => setLabelChecked(e.target.value)}
                        style={{ marginRight: '5px' }}
                      />
                      <label>{value.label}</label>
                      {/* <Checkbox name={value.label} value={value.label} checked={checkedItems[value.label]} onChange={handleChange} /> */}
                    </Col>
                  )
                })}
              </Row>
            </form>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger light" onClick={() => setIsVisible(false)}>
          ยกเลิก
        </Button>
        <Button variant="" type="primary" key="submit" className="btn btn-primary" onClick={() => createAdmin()}>
          แก้ไข
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
